import { useEffect, useRef, useState } from "react";

function DownloadNotice() {
  const barRef = useRef(null);
  const [visible, setVisible] = useState(() => {
    try {
      const navEntries = performance.getEntriesByType("navigation");
      const navType = navEntries.length > 0 ? navEntries[0].type : "navigate";
      if (navType === "reload") {
        sessionStorage.removeItem("barHidden");
      }
      const hidden = sessionStorage.getItem("barHidden") === "true";
      return !hidden;
    } catch {
      return true;
    }
  });
  const [appLogo, setAppLogo] = useState("");
  const [selectedBrand, setSelectedBrand] = useState('localhost');

  // Visible state initialized above to prevent flicker on reload

  // Fetch app logo from API (prefer mobile_logo -> logo -> loader_logo)
  useEffect(() => {
    let cancelled = false;
    const fetchLogo = async () => {
      try {
        if (!process.env.REACT_APP_API_URL) return;
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
        if (!res.ok) return;
        const json = await res.json();
        const item = Array.isArray(json) ? json[0] : json;
        const picked = item?.mobile_logo || item?.logo || item?.loader_logo || "";
        if (!cancelled) setAppLogo(picked || "");
      } catch (err) {
        // silent fallback
        console.debug("downloadNotice: using fallback logo");
      }
    };
    fetchLogo();
    return () => {
      cancelled = true;
    };
  }, []);

  // Brand detection
  useEffect(() => {
    const hostname = (window.location.hostname || '').toLowerCase();
    const origin = (window.location.origin || '').toLowerCase();
    const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();

    const isBeetbuzz = hostname.includes('beetbuzz') || origin.includes('beetbuzz') || brand.includes('beetbuzz');
    const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
    const is7xplay = hostname.includes('7xplay') || origin.includes('7xplay') || brand.includes('7xplay');
    const isBk8bd = hostname.includes('bk8bd') || origin.includes('bk8bd') || brand.includes('bk8bd');
    const isCb444 = hostname.includes('cb444') || origin.includes('cb444') || brand.includes('cb444');

    const selectedBrand = isBeetbuzz ? 'beetbuzz' : isLocalhost ? 'localhost' : (is7xplay || isBk8bd || isCb444) ? ((isBk8bd || isCb444) ? 'bk8bd' : '7xplay') : 'default';

    localStorage.setItem('brand', selectedBrand);
    setSelectedBrand(selectedBrand);
  }, []);

  // Hide bar handler
  const handleClose = (e) => {
    e.stopPropagation();
    sessionStorage.setItem("barHidden", "true");
    setVisible(false);
  };

  // While visible, push header down by the bar height
  useEffect(() => {
    const root = document.documentElement;
    if (visible) {
      const h = barRef.current?.offsetHeight || 0;
      root.style.setProperty("--download-bar-height", `${h}px`);
      root.classList.add("download-bar-open");
    } else {
      root.style.setProperty("--download-bar-height", "0px");
      root.classList.remove("download-bar-open");
    }
    return () => {
      root.style.setProperty("--download-bar-height", "0px");
      root.classList.remove("download-bar-open");
    };
  }, [visible]);

  // Measure header height and expose as CSS var for layout padding
  useEffect(() => {
    const root = document.documentElement;
    const setHeaderHeight = () => {
      const header = document.querySelector('header');
      const h = header ? header.offsetHeight : 0;
      root.style.setProperty('--header-height', `${h}px`);
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    return () => window.removeEventListener('resize', setHeaderHeight);
  }, []);

  const tryDownloadApk = async () => {
    const origin = window.location.origin
      .replace(/^https?:\/\/(www\.)?/, "")
      .replace(/(\.com|\.live|\.net|\.world)$/i, "");

    const candidates = [
      `${origin}`,
      `${selectedBrand}`,
      // Known APKs in public/app
      "worldbetlive",
      "worldbaji",
      "wicketwinner",
      "winbaji1",
      "7xwin",
      "bd77",
      "baji10x",
      "bajirma",
      "bigmama",
      "jeetbuzz44",
      "jetbuzz.top",
      "Jitbuzz",
      "jitbuzz88",
      "jitci777",
      "luckywin.site",
      "sixbaji",
    ];

    for (const name of candidates) {
      const url = `/app/${name}.apk`;
      try {
        let res = await fetch(url, { method: "HEAD" });
        if (!res || !res.ok) {
          res = await fetch(url, { method: "GET" });
        }
        if (res && res.ok) {
          window.location.href = url;
          return;
        }
      } catch {}
    }
    alert("Download unavailable right now. Please try again later.");
  };

  if (!visible) return null;

  const origin = window.location.origin
    .replace(/^https?:\/\/(www\.)?/, "")
    .replace(/(\.com|\.live|\.net|\.world)$/i, "");

  const logoSrc = appLogo && process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/storage/${appLogo.replace(/^\/?storage\//i, "")}`
    : "/logo.png";

  return (
    <div ref={barRef} className={`download-bar show-bar`}>
      <div className="download-bar-icon">
        <img src={logoSrc} alt="app-icon" />
      </div>

      <button type="button" className="download-bar-btn" onClick={tryDownloadApk}>Download</button>

      <div className="app-full-name-wrap">
        <span className="app-full-name">অ্যাপডাউনলোড</span>
      </div>

      {/* <div className="app-star-grade">
        <span className="star-icon" />
        <span className="star-icon" />
        <span className="star-icon" />
        <span className="star-icon" />
        <span className="star-icon" />
        <span className="grade-text">5.0</span>
      </div> */}
      <div className="download-bar-close" aria-label="Close" role="button" onClick={handleClose} />
    </div>
  );
}

export default DownloadNotice;
